import React from "react";

const formatPercent = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "—";
  }
  const sign = numeric >= 0 ? "+" : "";
  return `${sign}${numeric.toFixed(2)}%`;
};

const RANGE_OPTIONS = [
  { key: "1M", label: "1M" },
  { key: "3M", label: "3M" },
  { key: "1Y", label: "1Y" },
  { key: "Total", label: "ALL" },
];

export default function GrowthOfOne({
  growthPercent,
  growthReturns,
  growthRange,
  onGrowthRangeChange,
}) {
  const selectedRange = growthRange ?? "Total";

  const currentValue =
    (growthReturns && growthReturns[selectedRange]) ?? growthPercent;

  const subtitle =
    selectedRange === "Total" ? "Since Inception" : `Last ${selectedRange}`;

  const handleRangeClick = (key) => {
    if (onGrowthRangeChange) onGrowthRangeChange(key);
  };

  return (
    <div className="card growth-card">
      <div className="card-header">
        <div>
          <span className="card-title">
            Growth of <span className="dollar">$</span>1
          </span>
          <div className="card-subtitle">{subtitle}</div>
        </div>
        <div className="growth-value-row" style={{ textAlign: "right" }}>
          <div className="growth-range-tabs">
            {RANGE_OPTIONS.map((opt) => (
              <button
                key={opt.key}
                type="button"
                className={
                  "growth-range-btn" +
                  (selectedRange === opt.key ? " active" : "")
                }
                onClick={() => handleRangeClick(opt.key)}
              >
                {opt.label}
              </button>
            ))}
          </div>
          <div>
            <div className="growth-value">{formatPercent(currentValue)}</div>
            <div className="growth-label">Total Return</div>
          </div>
        </div>
      </div>
      <div className="chart-container">
        <canvas id="growthChart"></canvas>
      </div>
    </div>
  );
}
